export const localization = {
  pt: {
    title: 'Adicionar URL',
    subtitle: 'Adicione links de páginas da web confiáveis para criar uma base de conhecimento para seu agente.',
    input: { placeholder: 'https://www.exemplo.com.br', requiredErrorMessage: 'O campo URL é obrigatório.' },
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successToast: {
      title: 'Conteúdo adicionado',
      message: 'O conteúdo foi salvo e está disponível no catálogo.',
    },
    errorToast: {
      title: 'Falha ao adicionar o conteúdo',
      message: 'Não foi possível salvar o conteúdo. Tente novamente.',
    },
  },
  en: {
    title: 'Add URL',
    subtitle: 'Add links from trusted web pages to create a knowledge base for your agent.',
    input: { placeholder: 'https://www.example.com', requiredErrorMessage: 'The URL field is required.' },
    cancelButton: 'Cancel',
    saveButton: 'Save',
    successToast: {
      title: 'Content added',
      message: 'The content has been saved and is available in the catalog.',
    },
    errorToast: {
      title: 'Could not add content',
      message: 'Could not save the content. Please try again.',
    },
  },
  es: {
    title: 'Agregar URL',
    subtitle: 'Agrega enlaces de páginas web confiables para crear una base de conocimiento para tu agente.',
    input: { placeholder: 'https://www.ejemplo.com', requiredErrorMessage: 'El campo URL es obligatorio.' },
    cancelButton: 'Cancelar',
    saveButton: 'Guardar',
    successToast: {
      title: 'Contenido agregado',
      message: 'El archivo se ha importado correctamente y está siendo procesado.',
    },
    errorToast: {
      title: 'Fallo al agregar el contenido',
      message: 'No se pudo importar el archivo. Inténtalo de nuevo.',
    },
  },
};
